import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";
import { constructQueryString } from "../../helpers/Functions";

const api = new APICore();

export const getYouTubeAuthUrl = createAsyncThunk(
  "youtube/getAuthUrl",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(Url.GET_YOUTUBE_AUTH_URL);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getYouTubeAuthToken = createAsyncThunk(
  "youtube/token",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${Url.GET_YOUTUBE_AUTH_TOKEN}?${constructQueryString(data)}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const connectYouTube = createAsyncThunk(
  "youtube/connect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CONNECT_YOUTUBE, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createYouTubePost = createAsyncThunk(
  "youtube/createPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_YOUTUBE_POST, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getYouTubePost = createAsyncThunk(
  "youtube/getPosts",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(Url.GET_YOUTUBE_POST, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteYouTubePost = createAsyncThunk(
  "youtube/deletePost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.DELETE_YOUTUBE_POST, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
